import { render, staticRenderFns } from "./ClientAppSelector.vue?vue&type=template&id=3bec0e96&scoped=true&"
import script from "./ClientAppSelector.vue?vue&type=script&lang=js&"
export * from "./ClientAppSelector.vue?vue&type=script&lang=js&"
import style0 from "./ClientAppSelector.vue?vue&type=style&index=0&id=3bec0e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec0e96",
  null
  
)

export default component.exports